export default "__VITE_ASSET__BbNmJzvp__"